import React from 'react';

const Facts = ({ t }) => {
  return (
    <section className="facts">
      <h2 className="h2">{t.title}</h2>
      <div className="facts__content">
        <ul className="facts__list">
          {t.list.map((fact, index) => (
            <li key={index} className="fact">{fact}</li>
          ))}
        </ul>
        <div className="facts__illustrations">
          {/* Illustrations can be added here if needed */}
        </div>
      </div>
    </section>
  );
};

export default Facts;
